import { render, staticRenderFns } from "./OrderSides.vue?vue&type=template&id=71a3e3c8"
import script from "./OrderSides.vue?vue&type=script&lang=js"
export * from "./OrderSides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports